import SessionsPage from "./sessions";

function DashboardIndex() {
  return <SessionsPage />;
}

export default DashboardIndex;
